import { graphql, Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import Layout from '../../components/Layout/Layout'
import profileApi from '../../services/ProfileAPI'
import * as styles from './index.module.css'

function ForgotPassword(props) {
  const { contentfulAsset } = props.data
  const emailValue = useRef(null)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const requestReset = (event) => {
    event.preventDefault()
    setMessage('')
    setError('')

    const email = emailValue.current?.value?.trim()

    if (!email) {
      setError('Please enter your account email.')
      return
    }

    setLoading(true)
    profileApi.requestPasswordReset({ email })
      .then((res) => {
        setLoading(false)
        setMessage(res.data?.message || 'If that email is registered, a reset link will be sent shortly.')
      })
      .catch((err) => {
        setLoading(false)
        setError(err.response?.data?.message || 'Unable to request a reset link. Please try again.')
      })
  }

  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Forgot Password - Load&Lock</title>
      </Helmet>
      <div className={styles.resetPage}>
        <div className={styles.logo}>
          <GatsbyImage image={contentfulAsset.gatsbyImageData} alt={contentfulAsset.title} />
        </div>
        <h1>Reset your password</h1>
        <form className={styles.form} onSubmit={requestReset}>
          <label htmlFor='reset-email'>Account email</label>
          <input id='reset-email' type='email' ref={emailValue} autoComplete='email' />
          {error && <p className={styles.error}>{error}</p>}
          {message && <p className={styles.message}>{message}</p>}
          <button type='submit' className={styles.submitButton} disabled={loading}>
            {loading ? 'Sending...' : 'Send reset link'}
          </button>
        </form>
        <p className={styles.backLink}><Link to='/login'>Back to sign in</Link></p>
      </div>
    </Layout>
  )
}

export default ForgotPassword

export const pageQuery = graphql`
query ForgotPasswordPageQuery {
  contentfulAsset(title: {eq: "Logo"}) {
    gatsbyImageData(placeholder: TRACED_SVG)
    title
  }
}
`
